import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import SidebarComponent from "./sidebar.style";
import {
  sideBarMenuConfig,
  sideBarMenuSecondConfig,
} from "../../../constant/SidebarMenuConfig";
import Images from "../../../assets/images/index";
import moment from "moment";
import { useAccessControl } from "../../../helpers/hooks";
import CustomDropdown from "../../../component/common/Dropdown/customDropdown";
import "./sidebar.scss";
import {
  getBrandList,
  brandName,
  setStartTime1,
  setEndTime1,
  setSelectedStatus,
} from "../../../api/orders";
import { setUserBrand, setUserBrandId } from "../../../redux/slices/userSlice";
export default function Sidebar({ toggleSideBar, sideBarWidth, toggleAction }) {
  const navigate = useNavigate();
  const {
    Wrapper,
    Divider,
    Container,
    MenuList,
    MenuItem,
    Label,
    Icon,
    MenuToggler,
  } = SidebarComponent;

  const { orderType } = useSelector((state) => state.user);
  const { brandListData } = useSelector((state) => state.brands);
  const { roles } = useSelector((state) => state.user);

  const { hamburgerToggler } = Images;

  const dispatch = useDispatch();

  const [menuList, setMenuList] = useState(
    roles.toString() !== "USER"
      ? [...sideBarMenuConfig]
      : [...sideBarMenuSecondConfig]
  );

  const [isBrandLoader, setBrandLoader] = useState(true);
  const [selectedBrand, setSelectedBrand] = useState({});
  const [brandNames, setBrandNames] = useState([]);
  const accessControl = useAccessControl();

  const handleMenuClick = ({ id, route }) => {
    const menuListArr = JSON.parse(
      JSON.stringify(
        roles.toString() !== "USER"
          ? sideBarMenuConfig
          : sideBarMenuSecondConfig
      )
    );
    menuListArr.find((i) => i.id === id).isActive = true;
    setMenuList([...menuListArr]);
    if (menuListArr.find((i) => i.id === id).isActive) navigate(route);

    const startDate = moment().subtract(2, "day").format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");

    dispatch(setStartTime1(startDate));
    dispatch(setEndTime1(endDate));
    dispatch(setSelectedStatus([]));
  };

  const modifyTheBrandList = (brandData) => {
    const brandList = [];

    brandData.map((item) => {
      brandList.push({
        label: item?.brandName,
        value: item?.brandName,
        id: item?.brandId,
      });
    });
    setBrandNames(brandList);
    handlerBrandName(brandList?.[0]);
    setBrandLoader(false);

    console.log("brandlist", brandList);
  };

  useEffect(() => {
    if (brandListData.length > 0) {
      console.log("Data loaded:", brandListData);
      modifyTheBrandList(brandListData);
    } else {
      console.log("Brand data is still empty.");
    }
  }, [brandListData]);

  const getBrandNames = () => {
    if (brandListData.length === 0) {
      dispatch(getBrandList({}));
    }
  };

  const handlerBrandName = (brand) => {
    console.log("brand", brand);

    setSelectedBrand(brand);
    dispatch(brandName(brand));
    dispatch(setUserBrand(brand?.label));
    dispatch(setUserBrandId(brand?.id));
  };

  const toggleTheMenu = () => {
    toggleAction(!toggleSideBar);
    const startDate = moment().subtract(2, "day").format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");

    dispatch(setStartTime1(startDate));
    dispatch(setEndTime1(endDate));
    dispatch(setSelectedStatus([]));
  };

  useEffect(() => {
    setMenuList(
      roles.toString() !== "USER"
        ? [...sideBarMenuConfig]
        : [...sideBarMenuSecondConfig]
    );
  }, [roles]);
  return (
    <Wrapper toggleSidebar={toggleSideBar} sideBarWidth={sideBarWidth}>
      <MenuToggler
        open={toggleSideBar}
        src={hamburgerToggler}
        alt="hamburgertoggler"
        onClick={() => {
          toggleTheMenu();
        }}
      />
      <Container toggleSidebar={toggleSideBar} sideBarWidth={sideBarWidth}>
        <MenuList>
          {toggleSideBar && (
            <CustomDropdown
              className="brand-dropdown"
              options={brandNames}
              inputLabel={"Select a Brand"}
              onChange={(event) => handlerBrandName(event)}
              // onDropdownOpen={() => getBrandNames()}
              loader={isBrandLoader}
              selectedValue={selectedBrand?.label}
            />
          )}
          {menuList
            .filter(({ roles }) => accessControl(roles))
            .map((i, idx) => {
              return (
                <React.Fragment key={`menu-item__${idx + 1}`}>
                  <MenuItem
                    onClick={() => handleMenuClick(i)}
                    className={`${!i?.route ? "disabled" : ""}`}
                  >
                    <Icon
                      src={i.icon}
                      width="21px"
                      height="24px"
                      alt={i.title}
                    />
                    {toggleSideBar && (
                      <Label
                        active={
                          i.isActive || window.location.pathname === i.route
                        } // Window.location persists active menu during page refresh
                      >
                        {i.title}
                      </Label>
                    )}
                  </MenuItem>
                  {idx !== sideBarMenuConfig.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
        </MenuList>
      </Container>
    </Wrapper>
  );
}

Sidebar.propTypes = {
  toggleSideBar: PropTypes.bool,
  toggleAction: PropTypes.func,
  sideBarWidth: PropTypes.string,
};

Sidebar.defaultProps = {
  toggleSideBar: true,
  sideBarWidth: "311px",
  toggleAction: () => {},
};
